export const statuses = [
  { value: 'PENDING', name: 'status.PENDING' },
  { value: 'IN_PROGRESS', name: 'status.IN_PROGRESS' },
  { value: 'COMPLETED', name: 'status.COMPLETED' },
  { value: 'TERMINATED', name: 'status.TERMINATED' },
];
